module.exports = __webpack_public_path__ + "img/industry_cropped.d5c8d880.jpg";